// 이용약관·개인정보처리방침 게시본(v3) — 시행 단계 판정과 동의 문안 (순수 함수 · IO 없음)
//
// 원고: docs/ops/policy/published/*.md → scripts/build-legal-content.js → src/content/legal/generated.js
// 기획·근거: docs/ops/policy/legal-review-2026-09-09.md (§0-1 대표 결정 · §7 일정)
//
// 일정(대표 결정 2026-09-22 — 「약관은 바로 시행. 지금 당장」. 종전: 09-21 「9/23 공지 · 10/1 시행」, 09-09 「10/01 공지 · 10/31 시행」):
//   09/22  공지 시작과 시행이 같은 날 — 게시본 교체 + 첫 로그인 재동의(policy.version 상향은 별도 SQL, docs/ops/policy/activate-legal-v3.sql)
//          ⚠️ 자사 약관 제2조 3항은 7일(불리·중대한 변경은 30일) 사전 공지를 정하고 있다 — 같은 날 시행은 그 기간을 안 둔다(대표 결정 2026-09-22, 기록 목적)
//   10/01~ 유료 전환 별도 동의 창(paidConsentFrom) — 🔒 앞당기지 않는다. 전자상거래법 §13⑥ 은 전환 전 30일 이내의 동의를 요구하므로
//          9/23 에 받은 동의는 11/1 청구의 근거가 못 된다
//   11/01  멤버십 구독료 첫 청구 (변경 없음)
//
// 🔒 `canonicalLegalText()` 가 user_policy_consent.document_hash 의 원문이다. 문안을 고치면 반드시
//    policy.version(DB) 과 LEGAL_V3.version 을 같이 올린다 — 버전만으로는 「버전 안 올리고 문안만 고친」 실수를 못 잡는다.
//    ⚠ 예외(대표 지시 2026-09-22 밤 · 「약관 개정 바로 적용, 동의 팝업은 띄우지 않아」): 제28조 8~11항·제14조 1항 ㈔(플랫폼 직접 지급 수익의
//    신고 · 2026-11-01 시행 · 11월 발생분부터, 부칙 7)와 방침의 정산 증빙 캡처 항목은 **버전을 올리지 않고 문안만** 반영했다. 그래서 v3.5 동의 행의
//    document_hash 가 09-22 밤 이전/이후로 둘로 갈린다 — 이 조항의 재동의는 다음 버전 상향 때 함께 받는다. 개정 근거 docs/ops/policy/terms-naver-revenue-amendment.md
//    같은 방식 2건째(대표 지시 2026-09-23 「법무 검토 없이 진행」): 구글 연결 조항(약관 제5조의3·제5조의4·제13조 6항, 방침 3-1·제4장·제6·7장·제16장 4~6항, 2026-10-01 시행 · 09-23 공지)도
//    **버전을 올리지 않고 문안만** 반영. 연결하는 회원만 연결 화면(체크 A·B)에서 별도 동의하므로 전체 재동의 팝업은 띄우지 않는다. 문안 docs/ops/policy/youtube-oauth-amendment-2026-09-22.
//    같은 방식 3건째(대표 2026-10-08 「그 문안대로 가자」): 방침 제6장 수탁사 「본인확인기관(유료 서비스 시행 시 게시)」 → **엔에이치엔케이씨피 주식회사(NHN KCP)** 실명·항목,
//    제4장 「본인확인 결과」 행 「(유료 시)」 삭제 — 휴대폰 본인확인 개시에 따른 수탁자 **고지**(위탁은 동의가 아니라 공개 사항)라 버전 그대로. 영문 Chapter 6 같은 문장.md
//    같은 방식 4건째(대표 2026-10-09 「약관은 단어만 바꾸는거니까 그냥 바꿔」): 「구독」→「멤버십」 용어 정비 — 제10·16·17·18·19·20·21·26조와 방침의 「월 구독료」, 유료 전환 동의 문안(paid_change)의 「등급 구독료」·「설정 › 구독」까지.
//    내용(금액·기간·권리) 변경 없음이라 **버전을 올리지 않고 문안만** 반영 — v3.5·paid_change v1.0 의 document_hash 가 10-09 전/후로 갈린다. 재동의는 다음 버전 상향 때. 기록 docs/ops/decisions.md 2026-10-09.
//    같은 방식 5건째(대표 2026-10-23 「개인정보처리방침에 운영팀 대화 내용·첨부 파일도 넣고」): 방침 제2장 6호·3-1 「운영팀 대화방」·제4장(대화 내용 종료 후 3년 · 첨부 1년)·제6·7장 Supabase·제9장 5항·제13장.
//    운영팀이 대화방을 연 회원에게만 해당하는 항목 추가라 **버전을 올리지 않고 문안만** 반영 — v3.5 의 document_hash 가 10-23 전/후로 갈린다. 기록 docs/ops/decisions.md 2026-10-23 · docs/ops/ops-chat-room-plan.md.
//    같은 방식 6건째(대표 2026-10-26 「약관은 너가 말한대로 넣어줘」): 제11조의3 2항(11/1 시행) 기산점의 화이트리스트 처리에 「업로드 전에 화이트리스트 처리가
//    필요한 작품만 해당합니다」 단서 — 1차 화이트리스트 작품은 처리를 기다리지 않는다(마이그레이션 20261124100000). 시행 전 조항의 적용 범위 명시라
//    **버전을 올리지 않고 문안만** 반영 — v3.5 의 document_hash 가 10-26 전/후로 갈린다. 기록 docs/ops/decisions.md 2026-10-26.

import {
  TERMS_V3_MD, TERMS_V3_CHANGES_MD, PRIVACY_V3_MD, PRIVACY_V3_CHANGES_MD, PRIVACY_V3_EN_MD,
} from "../content/legal/generated";

export const LEGAL_V3 = Object.freeze({
  version: "v3.5", // 2026-09-22 제16·17·20·21·23·24조 유료 서비스 조항 갱신 — 「접근권」 → **승급권**(보유 기간 동안 실제로 그 등급이 된다 · 좌석 수 한정 · 개시 후 환불 없음), 가입비 구성, 결제 실패 재시도, 중도해지 폐지, 청약철회 범위, 휴면 6개월. 종전 v3.4: 2026-09-21 제11조의3(협업 약정과 불가피한 중단) 신설 · 방침 3-1·제4장 증빙 자료(민감정보) 항목 · 시행일 10/31 → 10/01, 공지 10/01 → 09/22(대표 결정 — 09/23 에서 하루 더 당겼다, docs/ops/series-completion-policy-plan.md). activate-legal-v3.sql 도 v3.4. 종전 v3.3: 2026-09-21 제14조 3항·제20조 4항. v3.2: 2026-09-19 제휴 파트너 링크 방문 집계 고지. v3.1: 2026-09-11 파트너 프로그램 조항
  noticeFrom: "2026-09-22",
  effectiveFrom: "2026-09-22", // 대표 결정 2026-09-22 「바로 시행」 — 공지일과 같은 날
  paidConsentFrom: "2026-10-01",
  paidFrom: "2026-11-01",
});

const KST_OFFSET = "+09:00";
const kstStart = (isoDate) => new Date(`${isoDate}T00:00:00${KST_OFFSET}`).getTime();

/** before(공지 전) · notice(공지 중 · 현행 유효) · effective(시행) */
export function legalPhase(now = new Date()) {
  const t = now.getTime();
  if (t >= kstStart(LEGAL_V3.effectiveFrom)) return "effective";
  if (t >= kstStart(LEGAL_V3.noticeFrom)) return "notice";
  return "before";
}

export const isLegalV3Effective = (now = new Date()) => legalPhase(now) === "effective";

/** 유료 전환 별도 동의를 받는 창 — 첫 청구 30일 전(paidConsentFrom)부터 첫 청구 전날까지. 약관 공지 시작일과 무관하다 */
export function isPaidChangeConsentWindow(now = new Date()) {
  const t = now.getTime();
  return t >= kstStart(LEGAL_V3.paidConsentFrom) && t < kstStart(LEGAL_V3.paidFrom);
}

// QA·디자인 검토용 강제 파라미터 — ?legal=before|notice|effective (TierRolloutInterstitial 의 ?rollout= 과 같은 패턴). 기록은 남기지 않는다.
export const LEGAL_QUERY_PARAM = "legal";
export function readForcedLegalPhase(search) {
  try {
    const v = new URLSearchParams(search || "").get(LEGAL_QUERY_PARAM);
    return v === "before" || v === "notice" || v === "effective" ? v : null;
  } catch {
    return null;
  }
}

export const LEGAL_DOCS = Object.freeze({
  terms: {
    key: "terms",
    title: "이용약관",
    path: "/terms-of-service",
    legacyPath: "/terms-of-service/2025",
    legacyLabel: "현행 약관 (2025-03-21 시행)",
    md: TERMS_V3_MD,
    changes: TERMS_V3_CHANGES_MD,
    en: null,
  },
  privacy: {
    key: "privacy",
    title: "개인정보처리방침",
    path: "/privacy-policy",
    legacyPath: "/privacy-policy/2026-08",
    legacyLabel: "현행 방침 (2026-08-25 개정)",
    md: PRIVACY_V3_MD,
    changes: PRIVACY_V3_CHANGES_MD,
    en: PRIVACY_V3_EN_MD,
  },
});

export const LEGAL_DOC_KEYS = Object.keys(LEGAL_DOCS);

/** document_hash 원문 — 키·버전·전문. 영문 참고본은 포함하지 않는다(한국어본이 우선). */
export function canonicalLegalText(key) {
  const doc = LEGAL_DOCS[key];
  if (!doc) return "";
  return `${key} ${LEGAL_V3.version}\n${doc.md}`;
}

// ---------------------------------------------------------------------------
// 만 14세 이상 확인 (대표 결정 5) — policy 표의 age_confirm 행과 짝
export const AGE_CONFIRM = Object.freeze({
  key: "age_confirm",
  version: "v1.0",
  label: "만 14세 이상입니다.",
  hint: "만 14세 미만은 가입할 수 없습니다. 만 19세 미만인 회원은 유료 서비스 이용과 정산 정보 등록 시 법정대리인 동의가 필요합니다.",
});
export const canonicalAgeConfirmText = () => `age_confirm ${AGE_CONFIRM.version}\n${AGE_CONFIRM.label}\n${AGE_CONFIRM.hint}`;

// ---------------------------------------------------------------------------
// 가입 화면 「개인정보 수집·이용 동의(필수)」 요약 — 개인정보보호법 §22 고지 4요소(항목·목적·기간·거부 시 불이익)
export const PRIVACY_SIGNUP_SUMMARY = Object.freeze({
  rows: [
    { k: "수집 항목", v: "이름, 닉네임, 생년월일, 휴대폰번호, 이메일, 비밀번호 (채널 등록·정산 시 채널 정보와 정산 정보를 추가로 받습니다)" },
    { k: "이용 목적", v: "회원 가입·승인, 본인 확인, 작품 협업 안내와 통지, 부정 이용 방지" },
    { k: "보유 기간", v: "회원 탈퇴 시까지 (정산·세무 기록 등 법령이 정한 항목은 그 기간 동안 보존)" },
    { k: "거부 시", v: "동의하지 않으면 회원 가입이 되지 않습니다" },
  ],
});

// ---------------------------------------------------------------------------
// 유료 전환 별도 동의 (전자상거래법 §13⑥ · 약관 제18조 4~6항 · 부칙 3) — policy 표의 paid_change 행과 짝
export const PAID_CHANGE = Object.freeze({ key: "paid_change", version: "v1.0" });

export function paidChangeConsentCopy({ tier, monthlyFee }) {
  const fee = Number(monthlyFee || 0).toLocaleString("ko-KR");
  return {
    title: "11월 1일부터 멤버십 구독료가 시작됩니다",
    lines: [
      { k: "내 등급", v: tier || "-" },
      { k: "월 멤버십 구독료", v: `${fee}원 (부가가치세 포함)` },
      { k: "첫 결제일", v: "2026년 11월 1일 · 그날 확정된 등급 기준" },
      { k: "이후", v: "매월 1일 자동 결제 · 등급이 오르면 그달부터 낮아진 멤버십 구독료" },
      { k: "해지", v: "설정 › 멤버십에서 언제든지 · 해지 후 다음 결제일부터 청구하지 않습니다" },
    ],
    consent: `11월 1일부터 월 ${fee}원이 등록한 결제수단으로 매월 자동 결제되는 것에 동의합니다. 멤버십 구독료가 오르는 등급 변동이 있으면 그때 다시 확인받습니다.`,
    note: "동의하지 않으면 11월 1일부터 청구 없이 신규 작품 사용 신청과 소재 다운로드가 잠시 멈춥니다. 이미 승인된 영상의 정산은 계속됩니다. 언제든 다시 동의하면 바로 재개됩니다.",
  };
}

export function canonicalPaidChangeText({ tier, monthlyFee }) {
  const c = paidChangeConsentCopy({ tier, monthlyFee });
  return `paid_change ${PAID_CHANGE.version}\n${c.title}\n${c.lines.map((l) => `${l.k}: ${l.v}`).join("\n")}\n${c.consent}`;
}

// QA 강제 — ?paidconsent=1
export function readForcedPaidConsent(search) {
  try {
    return new URLSearchParams(search || "").get("paidconsent") === "1";
  } catch {
    return false;
  }
}
